import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutCenterDirective } from './layout-center.directive';


@NgModule({
    declarations: [LayoutCenterDirective],
    imports: [
        CommonModule
    ],
    exports: [
        LayoutCenterDirective
    ]
})
export class LayoutCenterModule {}
